import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetPartnerOperationsCountProps = {
  partnerId: string;
  excludedTypes: string[];
};

export const getPartnerOperationsCount =
  ({ partnerId, excludedTypes }: GetPartnerOperationsCountProps) =>
  async (dispatch: Dispatch) => {
    const query = {
      params: { partnerId, excludedTypes },
    };

    try {
      const { data } = await axiosV2.get('/partners/operationsCount', query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
